import reducer from "./reducer";
export { default as vacations } from "./components/index";
export { default as vacationsReducerName } from "./constants";
export default reducer;
